import { render, staticRenderFns } from "./TotalReflectionViz.vue?vue&type=template&id=2f8ad98a&scoped=true"
import script from "./TotalReflectionViz.vue?vue&type=script&lang=js"
export * from "./TotalReflectionViz.vue?vue&type=script&lang=js"
import style0 from "./TotalReflectionViz.vue?vue&type=style&index=0&id=2f8ad98a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ad98a",
  null
  
)

export default component.exports